import { render, staticRenderFns } from "./ListPatient.vue?vue&type=template&id=27c2a816"
import script from "./ListPatient.vue?vue&type=script&lang=js"
export * from "./ListPatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports